import { render, staticRenderFns } from "./CollectDataDetail.vue?vue&type=template&id=5fc472bd&scoped=true&"
import script from "./CollectDataDetail.vue?vue&type=script&lang=js&"
export * from "./CollectDataDetail.vue?vue&type=script&lang=js&"
import style0 from "./CollectDataDetail.vue?vue&type=style&index=0&id=5fc472bd&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc472bd",
  null
  
)

export default component.exports